import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    s: undefined,
  },
  isOpenModalEndSession: false,
  isOpenModalEditSession: false,
  isOpenModalChangeEndOfDay: false,
  session: null,
}

export const processSlice = createAppSlice({
  name: 'process',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    toggleModalEndSession: create.reducer((state, { payload }) => {
      state.isOpenModalEndSession = !state.isOpenModalEndSession
    }),
    toggleModalEditSession: create.reducer((state, { payload }) => {
      state.isOpenModalEditSession = !state.isOpenModalEditSession
    }),
    toggleModalChangeEndOfDay: create.reducer((state, { payload }) => {
      state.isOpenModalChangeEndOfDay = !state.isOpenModalChangeEndOfDay
    }),
    setSession: create.reducer((state, { payload }) => {
      state.session = payload
    }),
  }),
  extraReducers: (builder) => {},
})

export const {
  setFetchOption,
  toggleModalEndSession,
  toggleModalEditSession,
  setSession,
  toggleModalChangeEndOfDay,
} = processSlice.actions

export default processSlice.reducer
